import { Component, OnInit } from '@angular/core';
import { Usuario } from '../../model/usuario';
import { UsuarioService } from '../../services/usuario.service';
import { ConsorciosService } from '../../services/consorcios.service';
import { Consorcio } from '../../model/consorcio';


@Component({
  selector: 'app-usuario-list',
  templateUrl: './usuario-list.component.html',
  styleUrls: ['./usuario-list.component.css']
})
export class UsuarioListComponent implements OnInit {

  public modoEdicion: boolean = false;
  public consorcio: Consorcio;
  public consorcios: Consorcio[];
  public usuarios: Usuario[];
  public usuarioSeleccionada: Usuario;
  public queryText: string;

  public filtro:string;
  constructor(
    private _consorcioService: ConsorciosService,
    private _usuarioService: UsuarioService
  ) { }

  ngOnInit() {
    this.filtro = "";
    this.usuarios = [];
    this.queryText = "";
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.usuarioSeleccionada = new Usuario();
  }

  cargarUsuarios() {

    this._usuarioService.findUsuarios(this.queryText)
      .subscribe(
      data => {
        this.usuarios = data
      },
      err => {
        console.clear();
        console.log(err._body);
      });
  }


  agregarRegistro() {
    this.usuarioSeleccionada = new Usuario();
    this.modoEdicion = true;
  }

  regresar() {
    this.modoEdicion = false;
    this.cargarUsuarios();
  }


  editarRegistro(usuario: Usuario) {
    this.usuarioSeleccionada = usuario;
    this.modoEdicion = true;
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/usuario-list/usuario-list.component.ts